export enum TimeStatus {
  PREPARATION = 'preparation',
  INTERDICTED = 'interdicted',
  OPEN = 'open',
  SCHEDULED = 'scheduled',
  REQUESTED = 'requested',
  RESERVED = 'reserved'
}
